module.exports = __webpack_public_path__ + "img/icon-eye.908e0e02.svg";